import { useEffect, useState } from 'react';

/**
 * The device's clock, ticking every `everyMs` while the screen is open, so a countdown or an
 * "Overdue · 2 h" moves without a refetch. Sample at half the unit a label prints (30 s for a
 * display in whole minutes, NextStopCard's reasoning) or it drifts against the minute.
 */
export function useNow(everyMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), everyMs);
    return () => clearInterval(id);
  }, [everyMs]);
  return now;
}
